import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Generic page-level header: title (required) + optional subtitle + meta and actions slots.
 *
 * Usage:
 * ```html
 * <app-page-header title="My Page" subtitle="Optional description.">
 *   <div meta>Record being edited</div>
 *   <ng-container actions>
 *     <button type="button" class="btn-primary btn-toolbar">Action</button>
 *   </ng-container>
 * </app-page-header>
 * ```
 *
 * @input title   - Main H1 text (required).
 * @input subtitle - Secondary paragraph rendered below the title (optional).
 * @slot  meta    - Projected content placed under the title, inside the heading block. For the
 *                  record the page is about (name, identifier); the page owns its styling.
 * @slot  actions  - Projected content placed in the right-hand toolbar area.
 */
@Component({
  selector: 'app-page-header',
  standalone: true,
  imports: [],
  templateUrl: './page-header.component.html',
  styleUrl: './page-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageHeaderComponent {
  /** Main page title rendered as an H1. */
  readonly title = input.required<string>();

  /** Optional subtitle paragraph rendered beneath the title. */
  readonly subtitle = input<string>('');
}
